import { StyleSheet } from "react-native";

export const ToggleStyle = StyleSheet.create({

	row: {
		flexDirection: "row",
		alignItems: "center",
		marginVertical: 5,
	},

	text: {
		width: "85%",
		fontSize: 16,
		color: "#222222",
	},

	toggle: {
		marginLeft: 10,
	},

});
